<template>
  <div>
    <template v-if="track.speakers">
      <speaker class="speaker" v-for="(speaker, key) in track.speakers" :speaker-config="speakerConfig" :speaker="speaker" :key="key"></speaker>
    </template>
    <!--<speaker v-if="track.speaker && track.speaker.name" :speaker-config="speakerConfig" :speaker="track.speaker"></speaker>-->
    <section class="con-track-info">
      <div class="container">
        <div class="left">
          <h5 v-if="track.time && $store.state.info.displayPresentationTime">
            <i class="icontfont icon-time"></i>时间：{{presentationTime}}
          </h5>
          <h5 v-if="track.address">
            <i class="iconfont icon-location"></i>地点：{{track.address}}
          </h5>
        </div>
        <div class="right">
          <h1>{{track.is_previous? '往届':''}}专题：{{track.topic}}</h1>
          <div class="content" v-html="track.description">
          </div>
        </div>
      </div>
    </section>

    <section class="con-track-present" v-if="this.presentations.length">
      <div class="container">
        <div class="present" v-for="(presentation, id) in presentations" :key="id" v-if="presentation">
            <div class="left">
              <div v-for="(sid,index) in presentation.speakerIds" :key="index" class="single-speaker" v-if="speakers[sid]">
                <h4>by
                  <a @click="location(presentation.id, presentation.is_previous)">{{speakers[sid].name}}</a>
                </h4>
                <h6>{{speakers[sid].company}}</h6><small>{{speakers[sid].position}}</small>
              </div>
            </div>
            <div class="right">
              <div class="title">
                <a @click="location(presentation.id, presentation.is_previous)">
                  {{presentation.title}}
                </a>
                <div class="tag" v-if="presentation.tag_ids && presentation.tag_ids.length">
                  所属领域：
                  <span v-for="(tid, indexT) in presentation.tag_ids" :key="indexT" v-if="tags[tid]">
                    {{tags[tid].name + (indexT !== (presentation.tag_ids.length - 1) ? '、': '')}}
                  </span>
                </div>
              </div>
              <div class="content" v-html="presentation.introduce"></div>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Speaker from 'gkConUI/com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  components: {
    Speaker
  },
  props: [
    'id'
  ],
  computed: {
    tags () {
      return this.$store.state.tags
    },
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [] }
    },
    presentations () {
      return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    },
    speakers () {
      return this.$store.state.speakers
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    }
  },
  mounted () {},
  beforeDestroy () {
  },
  methods: {
    location (id, isPrevious) {
      if (isPrevious !== true) {
        this.$router.push({ path: '/presentation/' + id })
      }
    }
  },
  watch: {}
}
</script>

<style lang="sass" scoped>

.speaker
  padding: 30px 0!important
.con-track-info
  background-color: #fff
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .left
    width: 345px
    padding-right: 30px
    flex-shrink: 0
    +mobile
      display: none
    h5
      color: #8e9ca9
      font-size: 16px
      line-height: 1.8
      margin-top: 9px
      display: flex
      align-items: center
      i.iconfont
        margin-right: 8px
        color: var(--primary-color)
      a
        color: inherit
        &:hover
          color: var(--primary-color)
      img
        width: 18px
        margin-right: 11px
    +mobile
      width: 100%
      text-align: center
  .right
    flex-grow: 1
    > h1
      color: #3e3a39
      font-size: 38px
      margin-bottom: 50px

.con-track-present
  background-color: #f5f7f8
  padding: 67px 0 56px 0
  .left
    width: 304px
    margint-left: 10px
    flex-shrink: 0
    display: flex
    flex-direction: column
    justify-content: center
    .single-speaker
      margin: 15px 0
      h4
        font-size: 20px
        color: #3e3a39
        a
          font-size: 20px
          color: var(--primary-color)
          &:hover
            color: var(--primary-color)
      h6, small
        font-size: 16px
        color: #8e9ca9
        margin-top: 9px
        line-height: 1.4em
  .right
    flex-grow: 1
    .title
      font-size: 30px
      padding-bottom: 13px
      margin-bottom: 20px
      a:hover
       color: var(--primary-color)
      .tag
        font-size: 14px
        color: #8e9ca9
  .present
    display: flex
    padding: 50px 42px
    border-left: 8px solid var(--primary-color)
    margin-bottom: 20px
    background-color: #fff
    color: #3e3a39
    &:hover
      box-shadow: 0 0 10px rgba(218, 227, 237, .8)

</style>
